const verticalAlignMap = {
    wrap: "wrap",
    nowrap: "nowrap",
};

export default verticalAlignMap;
